export default {
  SET_CURRENT_USER (state, user) {
    state.isAuthenticated = true
    state.currentUser = user
  },
  SET_IS_AUTHENTICATED (state, boolean) {
    state.isAuthenticated = boolean
  },
  SET_ADMINROLLE (state, adminRolle) {
    state.adminRolle = adminRolle
  },
  SET_MITARBEITERADDRESSID (state, mitarbeiterAddressID) {
    state.mitarbeiterAddressID = mitarbeiterAddressID
  },
  SET_VLAMS_USERS (state, vlamsUsers) {
    state.vlamsUsers = vlamsUsers
  }
}
